import moment from 'moment';
import firebase from './firebase';

export function loadInvitation(dispatch, invitationId) {
    dispatch({
        type: 'INVITATION_REQUEST',
        invitationId,
    });
    firebase.database().ref(`/invitations/${invitationId}`).on('value', (snapshot) => {
        dispatch({
            type: 'INVITATION_SUCCESS',
            invitationId,
            response: {
                result: snapshot.val(),
            },
            receivedAt: moment(),
        });
    });
}

export function hasLoadedInvitation(state, invitationId) {
    const status = state.invitation.invitations[invitationId];
    return {
        isFetching: status ? status.isFetching : false,
        hasError: status ? status.hasError : false,
    };
}



/** WEBPACK FOOTER **
 ** ./src/action/invitationActions.js
 **/